import GroupListPanel from "./groupListPanel.container";

export default GroupListPanel;
